const EMAIL_SETTINGS = {
  EMAIL_HEADER: 'تنظیمات ایمیل',
  EMAIL_SUBTITLE:
    'مدیریت ارسال ایمیل‌های پاسخ به پیام‌های آفلاین. در صورت ثبت ایمیل توسط کاربر، پاسخ‌های اپراتور پس از آنلاین شدن به صورت ایمیل برای کاربر ارسال می‌شوند.',
  EMAIL_SWITCH_LABEL: 'ارسال ایمیل به کاربران',
  EMAIL_SWITCH_GUIDE: 'ایمیل ارسال شود یا خیر',
  EMAIL_TITLE_LABEL: 'عنوان ایمیل های ارسالی',
  EMAIL_TITLE_GUIDE: 'عنوان ایمیلی که به کاربر ارسال میشود',
  EMAIL_TITLE_INPUT_PLACEHOLDER: 'مثال:  --operator-- از --channelName--',
};

export default EMAIL_SETTINGS;
